"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cootsHeight_1 = __importDefault(require("../../constants/cootsHeight"));
const cootsWidth_1 = __importDefault(require("../../constants/cootsWidth"));
const timePerCootsFrame_1 = __importDefault(require("../../constants/timePerCootsFrame"));
const Direction_1 = __importDefault(require("../../enums/Direction"));
const state_1 = __importDefault(require("../../state"));
const getCootsScreenCoords_1 = __importDefault(require("../getCootsScreenCoords"));
const getCootsDirection_1 = __importDefault(require("../getCootsDirection"));
const drawImage_1 = __importDefault(require("./drawImage"));
const getLaserPower_1 = __importDefault(require("../getLaserPower"));
const walkingThreshold_1 = __importDefault(require("../../constants/walkingThreshold"));
const runningThreshold_1 = __importDefault(require("../../constants/runningThreshold"));
const ZIndexType_1 = __importDefault(require("../../enums/ZIndexType"));
const isCootsInObstacle_1 = __importDefault(require("../isCootsInObstacle"));
const drawCoots = () => {
    const direction = (0, getCootsDirection_1.default)();
    const frameDirectionOffset = (direction === Direction_1.default.DownRight
        ? 1
        : direction === Direction_1.default.UpLeft
            ? 2
            : direction === Direction_1.default.UpRight
                ? 3
                : 0) * cootsWidth_1.default * 4;
    const frameAnimationOffset = Math.floor((state_1.default.currentTime % (timePerCootsFrame_1.default * 4)) / timePerCootsFrame_1.default) * cootsWidth_1.default;
    const sourceX = frameDirectionOffset + frameAnimationOffset;
    const hitObstacle = (0, isCootsInObstacle_1.default)();
    const laserPower = (0, getLaserPower_1.default)();
    const sourceY = (state_1.default.isInBed
        ? 4
        : hitObstacle
            ? 3
            : (laserPower >= runningThreshold_1.default)
                ? 2
                : (laserPower >= walkingThreshold_1.default)
                    ? 1
                    : 0) * cootsHeight_1.default;
    const centerScreenCoords = (0, getCootsScreenCoords_1.default)();
    const x = centerScreenCoords.x - 9;
    const y = centerScreenCoords.y - 16;
    const ySortZIndex = {
        ySortID: "coots",
        type: ZIndexType_1.default.YSort
    };
    (0, drawImage_1.default)("coots", 1, sourceX, sourceY, cootsWidth_1.default, cootsHeight_1.default, x, y, cootsWidth_1.default, cootsHeight_1.default, ySortZIndex);
};
exports.default = drawCoots;
